module.exports = __webpack_public_path__ + "static/img/ico101.a767d53c.svg";